export const GET_NFT = "GET_NFT";
export const GET_NFT_SUCCESS = "GET_NFT_SUCCESS";
export const NFT_API_ERROR = "NFT_API_ERROR";


